"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const BigQuantError_1 = require("../errors/BigQuantError");
const noError_1 = require("../helpers/noError");
const bigQuantError = (value, rule, key) => {
    const error = {
        type: BigQuantError_1.BigQuantErrorType,
        key: key,
        value: value,
        quant: rule.quant,
    };
    return {
        error: error,
    };
};
exports.validateBigQuant = (rule) => (value, key) => {
    if (!value.mod(rule.quant).eq(0)) {
        return bigQuantError(value, rule, key);
    }
    return noError_1.noError();
};
//# sourceMappingURL=validateBigQuant.js.map